// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"613":"83b8edca","787":"f3e10cc7"}[chunkId] + ".chunk.js";
};